import { FC } from 'react';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useApi } from '#hooks/use-api';
import { PageContext, PageContextType } from '#page/contexts';
import { Content } from '#page/components';

type PropsType = {
  id: number;
};

const PageContainer: FC<PropsType> = ({
  id,
}) => {
  const api = useApi();
  const { data, isFetching } = api.getApiPage().useLoadQuery(id);

  if (isFetching) {
    return <ContentLoader />;
  }

  const pageContextValue: PageContextType = {
    page: data.page,
  };

  return (
    <PageContext value={pageContextValue}>
      <Content />
    </PageContext>
  );
};

export { PageContainer };
